import { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { useLatestLoad } from '../../hooks/useLatestLoad';
import { fetchVouchers } from '../adminApi';
import { Skeleton } from '../../ui/Skeleton';
import { money } from '../../core/format/currency';
import { plural } from '../../core/format/text';
import type { RequestOptions } from '../../core/types/backend';

/** Op het overzicht: wat er nog openstaat op actieve cadeaubonnen. Klik voor de lijst. */
export function OutstandingVouchersTile() {
  const load = useCallback((opts: RequestOptions) => fetchVouchers({
    status: 'actief'
  }, opts), []);
  const {
    data,
    status
  } = useLatestLoad(load);
  return <Link to="/be/cadeaubonnen?status=actief" className="group block rounded-lg border border-line bg-white p-4 transition-colors duration-150 ease-soft hover:border-ink/30 sm:p-6" data-id="element-5549" data-mp="3qpwtgz468hq3">
      <span className="flex items-center justify-between text-[13px] text-muted" data-id="element-5550" data-mp="1oxidw6p3npcu">
        Openstaand in cadeaubonnen
        <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-soft group-hover:translate-x-0.5" strokeWidth={1.5} aria-hidden="true" data-id="element-5551" data-mp="21jpy5gqh29zv" />
      </span>
      {status === 'error' && !data ? <span className="mt-2 block text-[14px] text-muted" data-id="element-5552" data-mp="1sl4fzmowwwzm">Kon niet laden. Open de cadeaubonnen.</span> : !data ? <span className="mt-2 block" role="status" aria-label="Cadeaubonnen laden" data-id="element-5553" data-mp="1wnhdjnti9olb">
          <Skeleton className="h-9 w-28 rounded" data-id="element-5554" data-mp="2kbr576deh6kd" />
        </span> : <>
          <span className="mt-1 block font-display text-[2rem] font-light leading-tight tabular-nums text-ink" data-id="element-5555" data-mp="2p9k9ftv57qi0">{money(data.outstandingCents)}</span>
          <span className="block text-[13px] text-muted" data-id="element-5556" data-mp="2fk0q6n3ipumm">op {plural(data.total, 'actieve bon', 'actieve bonnen')} · nog uit te geven</span>
        </>}
    </Link>;
}